// Adapted from React Native AddItem.js for web (Material-UI/AntD/React)
import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Button, Input, Modal, Form, Select, Table, Spin } from 'antd';
import { useAuth } from '../../AuthProvider';
import { baseUrl_SPB } from '../../BaseUrl';

const AddItem = ({ visible, onCancel, onAddItem, taxOption }) => {
  const [form] = Form.useForm();
  const [selectedInventory, setSelectedInventory] = useState({});
  const [inventory, setInventory] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const auth = useAuth();

  useEffect(() => {
    if (!visible) return;
    setLoading(true);
    fetch(`${baseUrl_SPB}/api/v1/inventory/getinventories`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + auth.token,
      },
    })
      .then(res => res.json())
      .then(data => {
        setInventory(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [visible, auth.token]);

  const calculateItemTotal = () => {
    const price = parseFloat(selectedInventory.price) || 0;
    const quantity = parseInt(selectedInventory.rquantity) || 0;
    let total = price * quantity;
    if (taxOption === 'inclusive') {
      total = total * 1.1; // Add 10% tax
    }
    return total.toFixed(2);
  };

  const handleOk = () => {
    form.validateFields().then(() => {
      const item = {
        name: selectedInventory.itemName,
        price: selectedInventory.price,
        quantity: selectedInventory.rquantity,
        total: calculateItemTotal(),
        key: uuidv4(),
      };
      onAddItem(item);
      form.resetFields();
      setSelectedInventory({});
    });
  };

  // Inventory table columns
  const inventoryColumns = [
    { title: 'Name', dataIndex: 'itemName', key: 'itemName' },
    { title: 'SKU', dataIndex: 'sku', key: 'sku' },
    { title: 'Price', dataIndex: 'price', key: 'price' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
    {
      title: 'Select',
      key: 'select',
      render: (_, record) => (
        <Button size="small" onClick={() => {
          setSelectedInventory({
            itemName: record.itemName,
            price: record.price,
            rquantity: 1
          });
          form.setFieldsValue({ itemName: record.itemName, price: record.price, rquantity: 1 });
        }}>Select</Button>
      )
    }
  ];

  return (
    <Modal
      title="Add Item"
      open={visible}
      onCancel={onCancel}
      onOk={handleOk}
      okText="Save"
      cancelText="Cancel"
    >
      <div style={{ marginBottom: 16 }}>
        <Input
          placeholder="Search inventory by name or SKU"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ marginBottom: 8 }}
        />
        {loading ? <Spin /> : (
          <Table
            columns={inventoryColumns}
            dataSource={inventory.filter(item =>
              (!search ||
                (item.itemName && item.itemName.toLowerCase().includes(search.toLowerCase())) ||
                (item.sku && item.sku.toLowerCase().includes(search.toLowerCase()))
              )
            )}
            rowKey={record => record.id || record.sku || record.itemName}
            size="small"
            pagination={{ pageSize: 5 }}
          />
        )}
      </div>
      <Form form={form} layout="vertical">
        <Form.Item label="Product Name" name="itemName" rules={[{ required: true, message: 'Please enter product name' }]}> 
          <Input
            value={selectedInventory.itemName || ''}
            onChange={e => setSelectedInventory({ ...selectedInventory, itemName: e.target.value })}
          />
        </Form.Item>
        <Form.Item label="Price" name="price" rules={[{ required: true, message: 'Please enter price' }]}> 
          <Input
            type="number"
            value={selectedInventory.price || ''}
            onChange={e => setSelectedInventory({ ...selectedInventory, price: e.target.value })}
          />
        </Form.Item>
        <Form.Item label="Quantity" name="rquantity" rules={[{ required: true, message: 'Please enter quantity' }]}> 
          <Input
            type="number"
            value={selectedInventory.rquantity || ''}
            onChange={e => setSelectedInventory({ ...selectedInventory, rquantity: e.target.value })}
          />
        </Form.Item>
        <Form.Item label="Total">
          <Input value={calculateItemTotal()} disabled />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddItem;
